import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClient, HttpClientModule, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {LoadingComponent} from './loading/loading.component';
import {ErrorpopupComponent} from './popups/errorpopup/errorpopup.component';
import {provideTranslateService, TranslateLoader, TranslateModule, TranslatePipe} from '@ngx-translate/core';
import {provideTranslateHttpLoader, TranslateHttpLoader} from '@ngx-translate/http-loader';
import {ClickAndDoubleClickDirective} from './directives/click-and-double-click.directive';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SupportPopupModule} from '../components/support-popup/support-popup.module';

@NgModule({
  declarations: [LoadingComponent, ErrorpopupComponent, ClickAndDoubleClickDirective],
  // providers: [LoaderService, HttpInterceptProviders],
  exports: [LoadingComponent, ErrorpopupComponent, ClickAndDoubleClickDirective, SupportPopupModule, TranslatePipe],
  imports: [CommonModule,
    /*            TranslateModule.forRoot({
                    // loader: {
                    //     provide: TranslateLoader,
                    //     useFactory: httpTranslateLoader,
                    //     deps: [HttpClient]
                    // }
                })*/
    BrowserAnimationsModule,
    SupportPopupModule, TranslatePipe],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'en',
      lang: 'en'
    })]
})
export class SharedModule {
}

/*
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
*/
